import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
const data = {
  Objective:
    "The curriculum is to train the students to perfect professional with complete knowledge in theory, practical and clinical reasoning, diagnosis and treatment.",
  Eligibility:
    "HSC pass or any other examination equivalent to 10 + 2, HSC examination of any recognized board/university after 12 years of study with 50% mark PCB subjects",
  "Examination,-Methodology-And-Results": {
    "1st,-2nd,-3rd-and-4th-year": "Theory and practical examination",
    "Level of passing": "50% and above in both theory and Practical",
    "First class": "65% and above",
    "First class with distinction": "75% and above",
    Attendance: "Compulsory 80% in theory and 85% in practical",
    Results: "Declared by the M.U.H.S Nashik",
  },
  Duartion: "4 years and 6 months internship",
  Seats: "60",
  "Admission-Procedure":
    "Admission to BPTh course will be given as per the rules and regulations of Pravesh Niyantran Samiti, Mumbai, DMER, Mumbai and Maharashtra University of health sciences, Nashik.",
  "Fee-Structure":
    "The fees will be as directed by Shikshan Shulka Samiti of Govt of Maharashtra",
};

const Bpt = () => {
  const traverse_data = Object.entries(data);
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        {traverse_data.map((elem, i) => (
          <Typography key={i} variant="body2" my={2} fontSize={16}>
            <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
              {elem[0].includes("-") ? (
                <>{elem[0].split("-").join(" ")}</>
              ) : (
                <>{elem[0]}</>
              )}
            </span>
            <>
              {typeof elem[1] === "string" ? (
                <>&nbsp;-&nbsp;{elem[1]}</>
              ) : (
                <TableContainer>
                  <Table sx={{ maxWidth: 650 }}>
                    <TableBody>
                      {Object.entries(elem[1]).map((tabs, i) => (
                        <TableRow key={i}>
                          <TableCell
                            align="left"
                            sx={{
                              color: "primary.main",
                              pr: { xs: 2, md: 8 },
                              fontSize: 14,
                            }}
                          >
                            {tabs[0].includes("-") ? (
                              <>{tabs[0].split("-").join(" ")}</>
                            ) : (
                              <>{tabs[0]}</>
                            )}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{ color: "primary.main", fontSize: 14 }}
                          >
                            {tabs[1]}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          </Typography>
        ))}
      </Stack>
    </Box>
  );
};

export default Bpt;
